import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RealEstateTokenForm from './RealEstateTokenForm';
import './RealEstateTokenForm.css';
import {
  getRealEstateTokenFormRequest,
  getTokenRequest,
  getTokenEditRequest,
  resetTokenForm,
  editRealEstateTokenRequest,
  uploadImageRequest,
  uploadDocumentRequest,
  resetDocUrl,
} from '../../../redux/actions/tokenform';
import 'react-quill/dist/quill.snow.css';

RealEstateTokenForm.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
];

RealEstateTokenForm.modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image', 'video'],
    ['clean'],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};

RealEstateTokenForm.propTypes = {
  placeholder: PropTypes.string,
};

const mapStateToProps = state => ({
  token: state.token.token.item,
  url: state.token.publicURL.url,
  docURL: state.token.publicURL.docURL,
  fieldType: state.token.publicURL.fieldType,
});

const mapDispatchToProps = {
  getRealEstateTokenFormRequest,
  getTokenRequest,
  getTokenEditRequest,
  resetTokenForm,
  editRealEstateTokenRequest,
  uploadImageRequest,
  uploadDocumentRequest,
  resetDocUrl,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RealEstateTokenForm);
